import { clsx } from 'clsx';
import { ReactNode, Ref } from 'react';
import { NavLink, NavLinkProps } from '@/routes-utils/navigation.tsx';
import {
  menuItemLink,
  menuItemText,
  iconContainer,
} from './menu-action.css.ts';

export type MenuActionLinkProps = {
  icon: ReactNode;
  label: ReactNode;
  external?: boolean;
  ref?: Ref<HTMLAnchorElement>;
} & NavLinkProps;

export const MenuActionLink = function MenuActionLink({
  ref,
  icon,
  label,
  to,
  external,
  className,
  ...props
}: MenuActionLinkProps) {
  return (
    <NavLink
      ref={ref}
      to={to}
      target={external ? '_blank' : ''}
      className={clsx(menuItemLink, className)}
      prefetch="render"
      {...props}
    >
      <div className={iconContainer}>{icon}</div>
      <span className={menuItemText}>{label}</span>
    </NavLink>
  );
};
